import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { createContext } from 'react';

import { getCommunityReferralApi } from '@flipster/apis/v1/community';
import { timestampToDate } from '@flipster/utils/datetime';

import { authBunja } from '../shared/auth/state';

export const ReferralCampaignContext = createContext<string>(null as unknown as string);
const ReferralCampaignScope = createScopeFromContext(ReferralCampaignContext);

export const socialReferralBunja = bunja(() => {
  const campaignName = bunja.use(ReferralCampaignScope);
  const { isCookieLoggedInAtom } = bunja.use(authBunja);
  const communityReferralBaseAtom = atomWithQuery(() => ({
    queryKey: ['getCommunityReferralApi', campaignName],
    queryFn: () => getCommunityReferralApi({ campaignName }),
  }));
  const campaignAtom = atom((get) => get(communityReferralBaseAtom).data?.data.campaign);
  const isPendingAtom = atom((get) => get(communityReferralBaseAtom).isPending);
  const isCompletedAtom = atom((get) => {
    const campaign = get(campaignAtom);
    if (!campaign) return false;
    return timestampToDate(campaign.endAt)?.getTime() < Date.now();
  });
  const hasUnclaimedTasksAtom = atom((get) => {
    const isLoggedIn = get(isCookieLoggedInAtom);
    const hasUnclaimedTasks = !isLoggedIn || get(communityReferralBaseAtom).data?.data.hasUnclaimedRewardHubTasks;
    return hasUnclaimedTasks;
  });
  return {
    campaignName,
    campaignAtom,
    isPendingAtom,
    isCompletedAtom,
    hasUnclaimedTasksAtom,
  };
});
socialReferralBunja.debugLabel = 'socialReferralBunja';
